<template>
  <div
    class="py-5 px-11 rounded-md shadow-md flex flex-col justify-center align-center m-2 cursor-pointer"
  >
    <Avatar
      :size="100"
      :src="client.image"
      class="cursor-default m-auto mb-5"
    />
    <div class="mb-2">
      <FontAwesomeIcon icon="user" class="mr-3.5" />
      <span class="cursor-text">{{ client.name }}</span>
    </div>
    <div class="mb-5 flex flex-nowrap justify-center">
      <FontAwesomeIcon icon="envelope-open" class="mr-3.5" />
      <span class="truncate cursor-text">{{ client.email }}</span>
    </div>
    <Button outline icon="comments" @click.stop="messageClient">
      Message
    </Button>
  </div>
</template>

<script>
export default {
  name: "MyClientCard",
  props: {
    client: {
      type: Object,
      default: null
    }
  },
  computed: {
    image() {
      return this.client?.image ?? "img_fallback.png";
    }
  },
  methods: {
    messageClient() {
      let message = prompt(`Message to ${this.client.name}`);

      if (message) {
        this.$notify({
          type: "success",
          group: "foo",
          text: "Message was sent successfully!"
        });
      }
    }
  }
};
</script>

<style></style>
